import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import Placeholder from 'components/consumer/Placeholder';
import CtaButton from 'components/essentials/Cta/CtaButton';
import useZipCodeFromUser from 'global-state/zipCodeFromUser/useZipCodeFromUser';
import useIsZipCodeFromUserServiceable from 'global-state/isZipCodeFromUserServiceable/useIsZipCodeFromUserServiceable';
const PDPAddToBagButton = t0 => {
  const $ = _c(16);
  const {
    addingToCart: t1,
    addToCartError: t2,
    campaign,
    cartDisabled: t3,
    isStickyButton: t4,
    isCustomizeButton: t5,
    isLayoutRevamp: t6,
    loading: t7,
    onClick,
    show: t8
  } = t0;
  const addingToCart = t1 === undefined ? false : t1;
  const addToCartError = t2 === undefined ? null : t2;
  const cartDisabled = t3 === undefined ? false : t3;
  const isStickyButton = t4 === undefined ? false : t4;
  const isCustomizeButton = t5 === undefined ? false : t5;
  const isLayoutRevamp = t6 === undefined ? false : t6;
  const loading = t7 === undefined ? false : t7;
  const show = t8 === undefined ? true : t8;
  const zipCodeFromUser = useZipCodeFromUser();
  const isZipCodeFromUserServiceable = useIsZipCodeFromUserServiceable();
  if (loading) {
    let t9;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <Placeholder type="rect" loading={true} style={{
        height: "44px"
      }} />;
      $[0] = t9;
    } else {
      t9 = $[0];
    }
    return t9;
  }
  const buttonColor = isLayoutRevamp ? "brand" : "black";
  const t9 = !!zipCodeFromUser && !isZipCodeFromUserServiceable || addingToCart || cartDisabled;
  let t10;
  if ($[1] !== isStickyButton || $[2] !== onClick) {
    t10 = event => onClick(event, isStickyButton);
    $[1] = isStickyButton;
    $[2] = onClick;
    $[3] = t10;
  } else {
    t10 = $[3];
  }
  const t11 = campaign === "barbie" ? "hotpink" : buttonColor;
  const t12 = !show ? "-1" : undefined;
  const t13 = isCustomizeButton ? "Customize" : "Add to Bag";
  let t14;
  if ($[4] !== addingToCart || $[5] !== t10 || $[6] !== t11 || $[7] !== t12 || $[8] !== t13 || $[9] !== t9) {
    t14 = <CtaButton disabled={t9} data-xc="PDPAddToBagButton" onClick={t10} styling="solid-button" color={t11} block={true} tabIndex={t12} isLoading={addingToCart} className="min-w-[120px] px-4">{t13}</CtaButton>;
    $[4] = addingToCart;
    $[5] = t10;
    $[6] = t11;
    $[7] = t12;
    $[8] = t13;
    $[9] = t9;
    $[10] = t14;
  } else {
    t14 = $[10];
  }
  let t15;
  if ($[11] !== addToCartError) {
    t15 = addToCartError && <div className="text-sm font-bold text-red mt-4 text-center">{addToCartError}</div>;
    $[11] = addToCartError;
    $[12] = t15;
  } else {
    t15 = $[12];
  }
  let t16;
  if ($[13] !== t14 || $[14] !== t15) {
    t16 = <>{t14}{t15}</>;
    $[13] = t14;
    $[14] = t15;
    $[15] = t16;
  } else {
    t16 = $[15];
  }
  return t16;
};
PDPAddToBagButton.propTypes = {
  addingToCart: PropTypes.bool,
  addToCartError: PropTypes.string,
  campaign: PropTypes.string,
  cartDisabled: PropTypes.bool,
  isCustomizeButton: PropTypes.bool,
  isLayoutRevamp: PropTypes.bool,
  isStickyButton: PropTypes.bool,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  show: PropTypes.bool
};
export default PDPAddToBagButton;